const state = {
  user: null,
}

export default state
